import type { StartFailure } from './parseStartError'
import { messagesNow } from '@/i18n'
import { messages } from './messages'

/**
 * Шесть бизнес-отказов запуска отрисовки (§5.3). Все приходят как `422` с
 * объектным detail, то есть в ветку `business` — ветвление тут по `code`, и
 * `never`-исчерпывность `failureText` по `kind` оно не трогает.
 *
 * Два `no_image_targets` различаются ТОЛЬКО по `message` — прямое требование
 * контракта: «в курсе нечего рисовать» против «прислан пустой список».
 * Второй в под-проекте D недостижим (авто-режим шлёт `targets: null`), но
 * текст нужен: явные списки приходят в D2.
 */
export const imageFailureText = (code: string, message: string): string | null => {
  const m = messagesNow(messages)
  switch (code) {
    case 'no_image_targets':
      return /empty list/i.test(message) ? m.noTargetsSelected : m.allImagesDrawn
    case 'unknown_image_targets':
      // Ключи перечисляет сам бэк (первые пять) — показываем их как есть:
      // выдумывать за него, какие места он не опознал, нечем.
      return m.unknownImageTargets(message)
    case 'too_many_image_targets':
      return m.tooManyImageTargets
    case 'image_style_required':
      return m.imageStyleRequired
    case 'too_many_pilot_sets':
      // Из интерфейса недостижим (предлагаем 0 или 1 при потолке 4), но
      // фолбэк «Запуск невозможен» не объяснил бы автору ничего.
      return m.tooManyPilotSets
    default:
      return null
  }
}

/** Отказ «нет стиля картинок» — единственный, у которого есть осмысленное
 *  действие: увести автора в поле стиля курса. */
export const isStyleRequired = (failure: StartFailure | null): boolean =>
  failure?.kind === 'business' && failure.code === 'image_style_required'
